import { MercadoPagoCardAdapter } from "./adapters/MercadoPagoCardAdapter";
import { MercadoPagoPixAdapter } from "./adapters/MercadoPagoPixAdapter";
import { PayPalAdapter } from "./adapters/PayPalAdapter";
import { StripeCardAdapter } from "./adapters/StripeCardAdapter";
import type { PaymentMethodAdapter } from "./types";
import type { PaymentMethod, PaymentProvider } from "@/services/student/checkout/checkout.interfaces";

const adapters: PaymentMethodAdapter[] = [
  MercadoPagoPixAdapter,
  MercadoPagoCardAdapter,
  StripeCardAdapter,
  PayPalAdapter,
];

export const getPaymentAdapter = (
  provider: PaymentProvider,
  method: PaymentMethod
): PaymentMethodAdapter | undefined =>
  adapters.find((a) => a.provider === provider && a.method === method);
